'use strict';

export class CurationEditorHelper {
  public static INTERNAL_KEY_PARAM_NAME: string = '__internalKey__';
  public static INTERNAL_NEW_ITEM_PARAM_NAME: string = '__newItem__';
  public static CASES_ROOT: string = 'cases';
  public static CLINICAL_SIG_ROOT: string = 'clinicalSignificances';
  public static CLINICAL_TRIALS_ROOT: string = 'clinicalTrials';
  public static ERROR_DUPLICATE_ITEM: number = 409;
  public static ERROR_NOT_LATEST_REVISION: number = 422;
  public static ERROR_ITEM_NOT_FOUND: number = 404;
  public static MULTIPLE_CHOICES: number = 300;
  public static CURATION_DASHBOARD_CONTEXT = 'CURATION_DASHBOARD_CONTEXT';
  public static CURATION_ITEM_NOT_FOUND = {
    status: CurationEditorHelper.ERROR_ITEM_NOT_FOUND,
    error: {}
  }

  private static calculateMaxEvidence(noClinicalSignificancePublications: boolean, clinicalSignificances: any) {
    let tier: string;
    const maxGigLevels = { };
    if (noClinicalSignificancePublications) {
      tier = 'III';
      return { 'tier' : tier, 'maxGigLevels' : maxGigLevels};
    }
    if (!clinicalSignificances) {
      return;
    }
    const BENIGN_STR: string = 'zz';
    const EMPTY_TIER: string = 'zzz';
    tier = EMPTY_TIER;
    for (const item of clinicalSignificances) {
      if (item['deleted'] != true) {
        const sigType: string = item['significanceType']['code'];
        let EvidenceLevel: string = item['levelOfEvidence']['code'] && item['levelOfEvidence']['code'].toUpperCase();
        if (EvidenceLevel == 'BENIGN') {
          EvidenceLevel = BENIGN_STR; // benign is the lowest level
        }
        if (maxGigLevels[sigType]) {
          if (EvidenceLevel < maxGigLevels[sigType]) {
            maxGigLevels[sigType] = EvidenceLevel;
          }
        }
        else {
          maxGigLevels[sigType] = EvidenceLevel;
        }
        if (EvidenceLevel < tier) {
          tier = EvidenceLevel;
        }
      }
    }
    if (tier == BENIGN_STR) {
      tier = 'V';
    }
    return { 'tier' : tier, 'maxGigLevels' : maxGigLevels};
  }

  private static calculateTier(noClinicalSignificancePublications: boolean, tier: string): string {
    let tierCalc: string;
    if (noClinicalSignificancePublications) {
      return 'III';
    }
    switch (tier) {
      case 'A':
      case 'B':
        tierCalc = 'I';
        break;
      case 'C':
      case 'D':
        tierCalc =  'II';
        break;
      case 'E':
      case 'F':
        tierCalc =  'III';
        break;
      case 'V':
        tierCalc =  'IV';
        break;
      default:
        tierCalc =  '';
        break;
    }
    return tierCalc;
  }

  public static calculateTierFromCuration(noClinicalSignificancePublications: boolean, clinicalSignificances: any) {
    const BENIGN_STR: string = 'zz';
    let tier: string;
    const evidence = this.calculateMaxEvidence(noClinicalSignificancePublications, clinicalSignificances);
    tier = evidence != null && evidence.tier != null ? evidence.tier : '';
    if (tier == BENIGN_STR) {
      tier = 'V';
    }
    return this.calculateTier(noClinicalSignificancePublications, tier);
  }
}
